import React from "react";

const itemStyle = {
  background: "#ffffff",
  border: "1px solid #ececf3",
  borderRadius: "12px",
  padding: "12px",
  marginBottom: "10px",
};

const ActivityTimeline = ({ activities, onComplete, completingId }) => {
  return (
    <div>
      {activities.map((activity) => (
        <div key={activity.id} className="crm-timeline-item" style={itemStyle}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "12px",
            }}
          >
            <div>
              <div className="crm-timeline-item" style={{ fontWeight: 600 }}>
                {activity.subject || "Untitled activity"}
              </div>
              <div
                className="crm-timeline-item"
                style={{ fontSize: "13px", opacity: 0.8 }}
              >
                {activity.activity_type || "task"} • {activity.status || "open"}
              </div>
              <div
                className="crm-timeline-item"
                style={{ marginTop: "8px", fontSize: "14px" }}
              >
                {activity.description || ""}
              </div>
              <div
                className="crm-timeline-item"
                style={{ marginTop: "8px", fontSize: "12px", opacity: 0.7 }}
              >
                Due:{" "}
                {activity.due_at
                  ? new Date(activity.due_at).toLocaleString()
                  : "Not set"}
              </div>
            </div>

            {activity.status === "open" ? (
              <button
                onClick={() => onComplete(activity.id)}
                disabled={completingId === activity.id}
              >
                {completingId === activity.id ? "Completing..." : "Complete"}
              </button>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActivityTimeline;
